import {useEffect, useState} from 'react';
import {useLocation} from 'react-router';

import type {Location} from 'react-router';
// Custom hook to handle location changes including history.pushState
function useCustomLocation(): Location {
    const location = useLocation(); // Get initial location from react-router-dom
    const [currentLocation, setCurrentLocation] = useState<Location>(location);

    useEffect(() => {
        const handleLocationChanged = () => {
            setCurrentLocation({
                ...location,
                pathname: window.location.pathname,
                search: window.location.search,
                hash: window.location.hash,
            });
        };

        window.addEventListener('location-changed', handleLocationChanged);

        return () => {
            window.removeEventListener('location-changed', handleLocationChanged);
        };
    }, [location]);

    return currentLocation;
}

export default useCustomLocation;
